/**
 * organization
 */
export default {
  namespaced: true,
  state: {
    domain: null
  },
  
  mutations: {
    SET_DOMAIN (state, value) {
      state.domain = value
    }
  },
  getters: {
    domain: (state) => state.domain
  }
}
